import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slider.css";
import { Grid, Grow, Slide } from "@mui/material";

// Inicio imagenes Slider

// Seguro
import LetrasSeguro from "../../img/sliderProducts/Seguro/LetraSeguros.webp";
import FranjaSeguro from "../../img/sliderProducts/Seguro/Franja.webp";
import FondoSeguro from "../../img/sliderProducts/Seguro/FondoSeguros.webp";

// Aniversario
import Fondo from "../../img/sliderProducts/Aniversario/Fondo.webp";
import aniversario from "../../img/sliderProducts/Aniversario/26Aniversario.webp";
import FigurasAniversario from "../../img/sliderProducts/Aniversario/Letras.webp";
import ConfetiAniversario from "../../img/sliderProducts/Aniversario/Confeti.webp";

// Soli-Auto
import EstrenaYaSoli from "../../img/sliderProducts/SoliAuto/EstrenaYa.webp";
import Iva from "../../img/sliderProducts/SoliAuto/ivaSoliauto.webp";
import Troca from "../../img/sliderProducts/SoliAuto/troca.webp";
import Letrasvehiculos from "../../img/sliderProducts/SoliAuto/Letrasvehiculos.webp";
import LetrasPlazos from "../../img/sliderProducts/SoliAuto/Plazos.webp";

// Tarjeta Debito
import Letras from "../../img/sliderProducts/TarjetaDebito/DisenioLetras.webp";
import FondoTarjetaDeb from "../../img/sliderProducts/TarjetaDebito/Fondo.webp";
import Actor from "../../img/sliderProducts/TarjetaDebito/Actor.webp";

// Cajeros
import VisitanosCajeros from "../../img/sliderProducts/Cajeros/visitanos.webp";
import PresionaAquiCajeros from "../../img/sliderProducts/Cajeros/presionaAqui.webp";
import Cajeros from "../../img/sliderProducts/Cajeros/Cajeros.webp";

// App Movile
import Descarga from "../../img/sliderProducts/Aplicacion/descargaLetras.webp";
import CandadinCelLetras from "../../img/sliderProducts/Aplicacion/CandadinCelLetras.webp";
import NuestraApp from "../../img/sliderProducts/Aplicacion/nuestraApp.webp";
import CslhMovil from "../../img/sliderProducts/Aplicacion/cslhmovil.webp";
import CslhAmovil from "../../img/sliderProducts/Aplicacion/cslhamovil.webp";
import GooglePlay from "../../img/sliderProducts/Aplicacion/googlePlay.webp";
import AppStore from "../../img/sliderProducts/Aplicacion/appStore.webp";

// Ser socio
import FondoQuieresSerSocio from "../../img/sliderProducts/ComoSerSocio/Fondo.jpg";
import LetrasBeneficios from "../../img/sliderProducts/ComoSerSocio/beneficios.png";
import SerSocio from "../../img/sliderProducts/ComoSerSocio/SerSocio.png";
import Presiona from "../../img/sliderProducts/ComoSerSocio/presiona.png";

// Soli-Verde 
import FondoSoliVerde from "../../img/sliderProducts/SoliVerde/FondoSoliVerde.png";
import ActividadesSoliVerde from "../../img/sliderProducts/SoliVerde/Actividades.png";
import EquiposSoliverde from "../../img/sliderProducts/SoliVerde/EquiposSoliverde.png";
import LogoSoliVerde from "../../img/sliderProducts/SoliVerde/LogoSoliverde.png";

import { useNavigate } from "react-router-dom";

const NextArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <div className="slick-arrow next-arrow"></div>
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <div className="slick-arrow prev-arrow"></div>
    </div>
  );
};

const MyCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();
  //para redireccionar
  const handleCarouselClick = () => {
    if (currentSlide === 0) {
      navigate("/DetailsProduct/CREDITO/16");
    } if (currentSlide === 1) {
      navigate("/about");
    } if (currentSlide === 2) {
      navigate("/partners");
    } else if (currentSlide === 3) {
      navigate("/aplicacionMovil");
    } else if (currentSlide === 4) {
      navigate("/DetailsProduct/CREDITO/8");
    } else if (currentSlide === 5) {
      navigate("/DetailsProduct/AHORRO/11");
    } else if (currentSlide === 6) {
      navigate("/cajeros");
    } else if (currentSlide === 7) {
      navigate("/seguros");
    }
  };

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 6000,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    appendDots: (dots) => <ul style={{ margin: "0" }}>{dots}</ul>,
    customPaging: () => <div className="slick-dot"></div>,
    afterChange: (current) => {
      setCurrentSlide(current);
    },
  };

  const [animationStarted, setAnimationStarted] = useState(false);
  const [pulsateCount, setPulsateCount] = useState(0);
  useEffect(() => {
    setAnimationStarted(true);
  }, []);

  const handleEntered = () => {
    setPulsateCount((prevCount) => (prevCount + 1) % 3);
  };

  //Array con los componentes para redireccionar
  const slides = [
    // SOLI-Verde
    {
      content: (
        <div
          key={0}
          className="carousel-slide"
          style={{ width: "100%" }}
          onClick={() => {
            setCurrentSlide(0);
            handleCarouselClick();
          }}
        >
          <Grid container>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "73%", top: "10%" }}
            >
              <img
                src={FondoSoliVerde}
                alt="Fondo Soli-Verde"
                fetchpriority="high"
                loading="eager"
                decoding="async"
                style={{
                  maxWidth: "195vw",
                  height: "55vw",
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <div
                style={{
                  position: "relative",
                  left: "17%",
                  marginTop: "-12%",
                }}
              >
                <img
                  src={LogoSoliVerde}
                  alt="Logotipo del credito SoliVerde"
                  loading="eager"
                  decoding="async"
                  style={{
                    width: "58vw",
                    position: "absolute",
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={4}>
              <div
                style={{
                  position: "relative",
                  left: "7%",
                  marginTop: "36%",
                }}
              >
                <img
                  src={EquiposSoliverde}
                  alt="Equipos electrodomesticos"
                  loading="eager"
                  decoding="async"
                  style={{
                    width: "53vw",
                    position: "absolute",
                    left: "29%",
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={4}>
              <div
                style={{
                  position: "relative",
                  right: "187%",
                  marginTop: "55%",
                }}
              >
                <img
                  src={ActividadesSoliVerde}
                  alt="Letras mas y mejores servicios"
                  loading="eager"
                  decoding="async"
                  style={{
                    width: "40vw",
                    position: "absolute",
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      ),
    },

    //  Atualiza tu expediente
    {
      content: (
        <div
          key={1}
          className="carousel-slide"
          style={{ width: "100%" }}
          onClick={() => {
            setCurrentSlide(1);
            handleCarouselClick();
          }}
        >
          <Grid container>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "28%", top: "3%" }}
            >
              <img
                src={Fondo}
                alt="Fondo 26 aniversario"
                fetchpriority="high"
                loading="eager"
                decoding="async"
                style={{
                  maxWidth: "60vw",
                  height: "50vw",
                }}
              />
            </Grid>

            <Grid item xs={4}>
              <div
                style={{
                  position: "relative",
                  right: "20%",
                  top: "120%",
                }}
              >
                <img
                  src={aniversario}
                  alt="Letras Aniversario"
                  loading="eager"
                  decoding="async"
                  style={{
                    width: "36vw",
                    position: "absolute",
                    left: "32%",
                  }}
                />
              </div>
            </Grid>

            <Grid item xs={4}>
              <div
                style={{
                  position: "relative",
                  right: "60%",
                  marginTop: "-20%",
                }}
              >
                <img
                  src={FigurasAniversario}
                  alt="Festejos y palabras"
                  loading="eager"
                  decoding="async"
                  style={{
                    width: "85vw",
                    position: "absolute",
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={4}>
              <div
                style={{
                  position: "relative",
                  right: "195%",
                  marginTop: "-15%",
                }}
              >
                <img
                  src={ConfetiAniversario}
                  alt="Confeti "
                  loading="eager"
                  decoding="async"
                  style={{
                    width: "95vw",
                    position: "absolute",
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      ),
    },

    /*LetrasAniversario*/

    // Como ser socio
    {
      content: (
        <div
          key={2}
          className="carousel-slide"
          style={{ width: "100%" }}
          onClick={() => {
            setCurrentSlide(2);
            handleCarouselClick();
          }}
        >
          <Grid container>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "72%", top: "-85%" }}
            >
              <img
                src={FondoQuieresSerSocio}
                alt="Fondo Quieres Ser Socio"
                style={{
                  maxWidth: "123vw",
                  height: "55vw",
                }}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "65%", top: "-10%" }}
            >
              <img
                src={SerSocio}
                alt="Letras como ser socio"
                style={{
                  maxWidth: "300vw",
                  height: "50vw",
                }}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "70%", top: "310%" }}
            >
              <Grow
                in={animationStarted && currentSlide === 2}
                timeout={{ enter: 2000, exit: 2000 }}
                onEntered={handleEntered}
              >
                <img
                  src={LetrasBeneficios}
                  alt="Beneficios de ser socio"
                  style={{
                    maxWidth: "70vw",
                    height: "25vw",
                  }}
                />
              </Grow>
            </Grid>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "15%", top: "355%" }}
            >
              <Grow
                in={animationStarted && currentSlide === 2}
                timeout={{ enter: 2000, exit: 2000 }}
                onEntered={handleEntered}
              >
                <img
                  src={Presiona}
                  alt="Imagen para presionar aqui"
                  style={{
                    maxWidth: "45vw",
                    height: "26vw",
                    animation: "pulsate 1s infinite ease-in-out",
                    willChange: "transform",
                  }}
                />
              </Grow>
            </Grid>
          </Grid>
          <style>
            {`
          @keyframes pulsate {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
            }
          }
        `}
          </style>
        </div>
      ),
    },

    /*2da diapositiva*/
    {
      content: (
        <div
          key={3}
          className="carousel-slide"
          style={{ width: "100%" }}
          onClick={() => {
            setCurrentSlide(3);
            handleCarouselClick();
          }}
        >
          <Grid container>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", left: "10%", top: "-5%" }}
            >
              <Grow
                in={animationStarted && currentSlide === 3}
                timeout={{ enter: 2000, exit: 2000 }}
                onEntered={handleEntered}
              >
                <img
                  src={Descarga}
                  alt="Boton descarga"
                  style={{
                    maxWidth: "76vw",
                    height: "46vw",
                  }}
                />
              </Grow>
            </Grid>
            <Grid item xs={4}>
              <div
                style={{
                  position: "relative",
                  left: "-21%",
                  marginTop: "-18%",
                }}
              >
                <img
                  src={CandadinCelLetras}
                  alt="Mascota CSLH"
                  style={{
                    width: "270%",
                    position: "absolute",
                    left: "36%",
                  }}
                />
              </div>
            </Grid>

            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "57%", top: "-150%" }}
            >
              <img
                src={NuestraApp}
                alt="Letras aplicacion"
                style={{
                  maxWidth: "78vw",
                  height: "68vw",
                  animation:
                    pulsateCount < 2 ? "pulsate 1s infinite" : "none",
                }}
              />
            </Grid>

            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "44%", top: "160%" }}
            >
              <Grow
                in={animationStarted && currentSlide === 3}
                timeout={{ enter: 2000, exit: 2000 }}
                onEntered={handleEntered}
              >
                <img
                  src={CslhMovil}
                  alt="Boton android"
                  style={{
                    maxWidth: "155vw",
                    height: "29vw",
                  }}
                />
              </Grow>
            </Grid>

            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "53%", top: "160%" }}
            >
              <Grow
                in={animationStarted && currentSlide === 3}
                timeout={{ enter: 2000, exit: 2000 }}
                onEntered={handleEntered}
              >
                <img
                  src={CslhAmovil}
                  alt="Boton Iphone"
                  style={{
                    maxWidth: "155vw",
                    height: "29vw",
                  }}
                />
              </Grow>
            </Grid>

            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "32%", top: "451%" }}
            >
              <Grow
                in={animationStarted && currentSlide === 3}
                timeout={{ enter: 2000, exit: 2000 }}
                onEntered={handleEntered}
              >
                <img
                  src={GooglePlay}
                  alt="Google play"
                  style={{
                    maxWidth: "21vw",
                    height: "11vw",
                  }}
                />
              </Grow>
            </Grid>

            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "59%", top: "451%" }}
            >
              <Grow
                in={animationStarted && currentSlide === 3}
                timeout={{ enter: 2000, exit: 2000 }}
                onEntered={handleEntered}
              >
                <img
                  src={AppStore}
                  alt="Letras Ios"
                  style={{
                    maxWidth: "21vw",
                    height: "11vw",
                  }}
                />
              </Grow>
            </Grid>
          </Grid>
          <style>
            {`
          @keyframes pulsate {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
            }
          }
        `}
          </style>
        </div>
      ),
    },

    /*Diapositiva soli-Auto*/
    {
      content: (
        <div
          key={4}
          className="carousel-slide"
          style={{ width: "100%" }}
          onClick={() => {
            setCurrentSlide(4);
            handleCarouselClick();
          }}
        >
          <Grid container>
            <Grid item xs={5}>
              <Slide
                direction="down"
                in={currentSlide === 4}
                mountOnEnter
                unmountOnExit
                timeout={{ enter: 1000, exit: 1000 }}
              >
                <div
                  style={{
                    position: "relative",
                    right: "50%",
                    marginTop: "-39%",
                  }}
                >
                  <img
                    src={Letrasvehiculos}
                    alt="Letras Soli-auto"
                    style={{
                      width: "180%",
                      position: "absolute",
                      left: "51%",
                    }}
                  />
                </div>
              </Slide>
            </Grid>

            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "10%", top: "5%" }}
            >
              <Grow
                in={animationStarted && currentSlide === 4}
                timeout={{ enter: 2000, exit: 2000 }}
                onEntered={handleEntered}
              >
                <img
                  src={EstrenaYaSoli}
                  alt="Letras estrena ya"
                  style={{
                    maxWidth: "100vw",
                    height: "29vw",
                    animation:
                      pulsateCount < 2 ? "pulsate 1s infinite" : "none",
                  }}
                />
              </Grow>
            </Grid>

            {currentSlide === 4 && (
              <div
                style={{
                  position: "absolute",
                  left: "65%",
                  top: "110%",
                  zIndex: 1,
                  pointerEvents: "none",
                }}
              >
                <Grow
                  in={animationStarted && currentSlide === 4}
                  timeout={{ enter: 2000, exit: 2000 }}
                  onEntered={handleEntered}
                >
                  <img
                    src={LetrasPlazos}
                    alt="Letras plazos"
                    style={{
                      width: "33vw",
                      height: "auto",
                    }}
                  />
                </Grow>
              </div>
            )}

            <Grid item xs={4}>
              <Slide
                direction="left"
                in={currentSlide === 4}
                mountOnEnter
                unmountOnExit
                timeout={{ enter: 1000, exit: 1000 }}
              >
                <div
                  style={{
                    position: "relative",
                    right: "110%",
                    marginTop: "29%",
                  }}
                >
                  <img
                    src={Troca}
                    alt="Troca Soli-auto"
                    style={{
                      width: "180%",
                      position: "absolute",
                      left: "45%",
                    }}
                  />
                </div>
              </Slide>
            </Grid>

            <Grid item xs={4}>
              <Slide
                direction="up"
                in={currentSlide === 4}
                mountOnEnter
                unmountOnExit
                timeout={{ enter: 1000, exit: 1000 }}
              >
                <div
                  style={{
                    position: "relative",
                    right: "20%",
                    marginTop: "28%",
                  }}
                >
                  <img
                    src={Iva}
                    alt="Troca Soli-auto"
                    style={{
                      width: "69%",
                      position: "absolute",
                      left: "23%",
                    }}
                  />
                </div>
              </Slide>
            </Grid>

          </Grid>
          <style>
            {`
          @keyframes pulsate {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.05);
            }
          }
        `}
          </style>
        </div>
      ),
    },

    /*4ta diapositiva*/
    {
      content: (
        <div
          key={5}
          className="carousel-slide"
          style={{ width: "100%" }}
          onClick={() => {
            setCurrentSlide(5);
            handleCarouselClick();
          }}
        >
          <Grid container>
            <Grid
              item
              xs={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grow
                in={currentSlide === 5}
                timeout={{ enter: 2000, exit: 2000 }}
              >
                <img
                  src={Letras}
                  alt="Letras plazos"
                  style={{
                    width: "90vw",
                    position: "relative",
                    left: "100%",
                    marginTop: "-16%",
                  }}
                />
              </Grow>
            </Grid>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", left: "66%", top: "1%" }}
            >
              <Slide
                direction="right"
                in={currentSlide === 5}
                mountOnEnter
                unmountOnExit
                timeout={{ enter: 2000, exit: 2000 }}
              >
                <img
                  src={Actor}
                  alt="Actris"
                  style={{ maxWidth: "46vw", height: "46vw" }}
                />
              </Slide>
            </Grid>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "67%", top: "72%" }}
            >
              <img
                src={FondoTarjetaDeb}
                alt="Fondo Tarjetra Debito"
                style={{
                  maxWidth: "100vw",
                }}
              />

            </Grid>
          </Grid>
        </div>
      ),
    },

    /*5ta diapositiva*/
    {
      content: (
        <div
          key={6}
          className="carousel-slide"
          style={{ width: "100%" }}
          onClick={() => {
            setCurrentSlide(6);
            handleCarouselClick();
          }}
        >
          <Grid container>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "64%", top: "2%" }}
            >
              <Slide
                direction="right"
                in={currentSlide === 6}
                mountOnEnter
                unmountOnExit
                timeout={{ enter: 2000, exit: 2000 }}
              >
                <img
                  src={VisitanosCajeros}
                  alt="Letras Visitanos cajero"
                  style={{ maxWidth: "77vw", height: "32vw" }}
                />
              </Slide>
            </Grid>
            <Grid
              item
              xs={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <img
                src={Cajeros}
                alt="Cajeros"
                style={{
                  width: "88%",
                  position: "relative",
                  left: "208%",
                  top: "-16%",
                }}
              />
            </Grid>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", left: "40%", top: "69%" }}
            >
              <Slide
                direction="up"
                in={currentSlide === 6}
                mountOnEnter
                unmountOnExit
                timeout={{ enter: 2000, exit: 2000 }}
              >
                <img
                  src={PresionaAquiCajeros}
                  alt="Presiona aqui Cajeros"
                  style={{ maxWidth: "31vw", height: "15vw" }}
                />
              </Slide>
            </Grid>
          </Grid>
        </div>
      ),
    },
    {
      content: (
        <div
          key={7}
          className="carousel-slide"
          style={{ width: "100%" }}
          onClick={() => {
            setCurrentSlide(7);
            handleCarouselClick();
          }}
        >
          <Grid container>
            <Grid
              item
              xs={4}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grow
                in={currentSlide === 7}
                timeout={{ enter: 2000, exit: 2000 }}
              >
                <img
                  src={FondoSeguro}
                  alt="Letras plazos"
                  style={{
                    width: "100vw",
                    position: "relative",
                    left: "100%",
                    marginTop: "-35%",
                  }}
                />
              </Grow>
            </Grid>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "67%", top: "-3%" }}
            >
              <Slide
                direction="right"
                in={currentSlide === 7}
                mountOnEnter
                unmountOnExit
                timeout={{ enter: 2000, exit: 2000 }}
              >
                <img
                  src={FranjaSeguro}
                  alt="Actris"
                  style={{ maxWidth: "122vw", height: "52vw" }}
                />
              </Slide>
            </Grid>
            <Grid
              item
              xs={4}
              style={{ position: "absolute", right: "62%", top: "-1%" }}
            >
              <img
                src={LetrasSeguro}
                alt="Fondo Tarjetra Debito"
                style={{
                  maxWidth: "92vw",
                }}
              />

            </Grid>
          </Grid>
        </div>
      ),
    },
  ];

  return (
    <div className="carousel-container">
      <Slider {...settings}>{slides.map((slide) => slide.content)}</Slider>
      <div className="carousel-buttons">
        <NextArrow />
        <PrevArrow />
      </div>
    </div>
  );
};

export default MyCarousel;
